/**
 * Converts a camelCase or PascalCase string to kebab-case format.
 *
 * Features:
 * - Handles camelCase to kebab-case conversion
 * - Handles PascalCase to kebab-case conversion
 * - Preserves consecutive numbers without separators
 * - Adds hyphens before uppercase letters and numbers
 * - Maintains lowercase letters as-is
 * - Handles edge cases like single characters and empty strings
 * - Preserves existing hyphens in the input string
 *
 * @param str - The string to convert to kebab-case
 * @returns The kebab-case version of the input string
 */
export function kebabize(str: string) {
  return str
    .split("")
    .map((letter, idx) => {
      const prevChar = str[idx - 1];

      if (!isNaN(parseFloat(letter))) {
        if (!isNaN(parseFloat(prevChar))) {
          return letter;
        }
        return `${idx !== 0 ? "-" : ""}${letter.toLowerCase()}`;
      }

      return letter.toUpperCase() === letter
        ? `${idx !== 0 ? "-" : ""}${letter.toLowerCase()}`
        : letter;
    })
    .join("");
}
